console.log('BUILD_TAG: new-ui-20251206');
import React from 'react';
import ReactDOM from 'react-dom/client';
import './theme/design.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Optional: global error boundary (to prevent blank screen if any render error occurs)
function GlobalErrorBoundary({ children }) {
  return (
    <React.StrictMode>
      {children}
    </React.StrictMode>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <GlobalErrorBoundary>
    <App />
  </GlobalErrorBoundary>
);

// Optional: log performance metrics
reportWebVitals(console.log);